/* eslint-disable */
// SMRTVZN — Module export rapport PDF (isolé, aucune dépendance au reste de l'app)
// Usage: import { exportCampaignReportPDF } from "./smrtvznReport";
import logoWhite from "./smrtvzn-logo-white.png";
import logoBlue from "./smrtvzn-logo-blue.png";

// ── REPLI : déduit la plateforme et le @handle depuis l'URL ───────────────────
// Utilisé quand un post n'a pas de profil enregistré en base (ex : enrichissement
// API qui a échoué à l'ajout). Reproduit la logique d'affichage du dashboard pour
// que l'export ne perde plus les posts dont le `account` n'a pas été persisté.
const _platFromUrl = (u = "") =>
  /tiktok\.com/i.test(u) ? "TikTok"
  : /(?:\/\/|\.)(?:x|twitter)\.com/i.test(u) ? "Twitter"
  : /instagram\.com/i.test(u) ? "Instagram"
  : "Other";
const _acctFromUrl = (u = "", plat) => {
  try {
    const p = plat || _platFromUrl(u);
    if (p === "TikTok" && u.includes("@")) return "@" + u.split("@")[1].split("/")[0];
    if (p === "Instagram") { const s = u.split("instagram.com/")[1]?.split("/"); return s && s[0] && !["p", "reel", "reels", "tv"].includes(s[0]) ? "@" + s[0] : ""; }
    if (p === "Twitter") { const s = u.replace(/https?:\/\/(www\.)?(x|twitter)\.com\//i, ""); return "@" + s.split("/")[0]; }
  } catch {}
  return "";
};

// ── EXPORT PDF — RAPPORT CAMPAGNE SMRTVZN (modulaire, DA blueprint IKB) ────────
// Génère un rapport client multi-sections depuis les données live de la campagne :
// synthèse + KPIs, répartition plateformes, types de contenu, clip farming,
// détail par créateur (multi-réseaux, liens cliquables), planning, bandeau outro.
// Pagination SHEET nn/NN. Impression navigateur (Enregistrer en PDF). 0 dépendance.
export function exportCampaignReportPDF(client, posts, baseData, influenceData, planningData) {
  const IKB = "#10069F", ACC = "#2F4BFF";
  const fr  = n => Math.round(n || 0).toLocaleString("fr-FR").replace(/\u202f/g, " ");
  const fmtK = n => { if (!n) return "0"; if (n >= 1e6) return (n/1e6).toFixed(1).replace(/\.0$/,"")+"M"; if (n >= 1e3) return Math.round(n/1e3)+"K"; return String(Math.round(n)); };
  const esc = s => String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  const clip = (baseData && baseData.clipping) || null;
  const objectives = (baseData && baseData.objectives) || [];
  const planning = planningData || [];

  // ── META ────────────────────────────────────────────────────────────────────
  const artiste = client.label || client.name || "—";
  const titre   = client.project || "—";
  const pkg     = client.pkg || client.package || null;
  const dStart  = client.dateStart || client.date_start || null;
  const dEnd    = client.dateEnd   || client.date_end   || null;
  const periode = (dStart && dEnd) ? `${dStart} → ${dEnd}` : (dStart || dEnd || null);
  const now = new Date();
  const pad = x => String(x).padStart(2,"0");
  const dateEd = `${pad(now.getDate())}\u00B7${pad(now.getMonth()+1)}\u00B7${String(now.getFullYear()).slice(2)} / ${pad(now.getHours())}:${pad(now.getMinutes())}`;

  // ── DÉTAIL (schéma réel: followers/views/comments|replies/shares|reposts ; plateformes "TikTok"/"Twitter"/"Instagram") ──
  const ORDER = ["TikTok","Twitter","Instagram"];
  const PLAT_LABEL = { TikTok:"TIKTOK", Twitter:"TWITTER / X", Instagram:"INSTAGRAM" };
  const PLAT_NICE  = { TikTok:"TikTok", Twitter:"Twitter / X", Instagram:"Instagram" };
  const detail = (posts||[])
    // On garde les liens courts vm.tiktok.com / vt.tiktok.com (vrais posts) ; on
    // n'exclut que les pages "son" TikTok. Le @handle/plateforme sont déduits de l'URL ci-dessous.
    .filter(p => p.url && !p.url.includes("tiktok.com/music"))
    .map(p => {
      const vues = p.views || p.impressions || p.imp || 0;
      const likes = p.likes || 0;
      const comments = (p.comments != null ? p.comments : p.replies) || 0;
      const shares = (p.shares != null ? p.shares : p.reposts) || 0;
      const eng = vues > 0 ? (likes + comments + shares) / vues * 100 : 0;
      const platform = p.platform || _platFromUrl(p.url);
      const account = p.account || _acctFromUrl(p.url, platform) || "—";
      return { account, platform: platform || "Other", contentType:p.contentType||p.type||"Autre",
        followers:p.followers||0, reach:p.reach||0, vues, likes, comments, shares, saves:p.saves||0, eng, url:p.url };
    });
  const platsPresent = [...ORDER.filter(p=>detail.some(d=>d.platform===p)), ...[...new Set(detail.map(d=>d.platform))].filter(p=>!ORDER.includes(p))];
  const groups = platsPresent.map(p => ({ platform:p, label:PLAT_LABEL[p]||p.toUpperCase(),
    rows: detail.filter(d=>d.platform===p).sort((a,b)=>b.followers-a.followers) })).filter(g=>g.rows.length);

  // ── KPIs / RÉPARTITION / TYPES — dérivés des posts (fallback influenceData saved) ──
  const sum = (arr,k) => arr.reduce((s,x)=>s+(x[k]||0),0);
  // reach = somme des abonnés par CRÉATEUR UNIQUE (un créateur compté une fois), jamais les vues.
  const aggReach = (arr) => {
    const m = {};
    for (const d of (arr||[])) {
      const k = (d.account||"").replace(/^@/,"").trim().toLowerCase()+"@@"+(d.platform||"");
      const f = Number(d.followers)||0;
      if (m[k] === undefined || f > m[k]) m[k] = f;
    }
    return Object.values(m).reduce((s,f)=>s+f,0);
  };
  const sd = influenceData || {};
  const hasPosts = detail.length > 0;
  const totVues  = sum(detail,"vues");
  const totReach = aggReach(detail);
  const engActs  = sum(detail,"likes")+sum(detail,"comments")+sum(detail,"shares");
  const nbPosts  = hasPosts ? detail.length : (sd.posts||0);
  const engMoy   = hasPosts ? (totVues>0?engActs/totVues*100:0)
                            : ((sd.imp>0)?(((sd.likes||0)+(sd.comments||0)+(sd.shares||0))/sd.imp*100):0);
  const breakdown = hasPosts
    ? groups.map(g => ({ platform: PLAT_NICE[g.platform]||g.platform, posts:g.rows.length,
        reach: aggReach(g.rows), imp: sum(g.rows,"vues"),
        likes: sum(g.rows,"likes"), shares: sum(g.rows,"shares") }))
    : (sd.breakdown || []);
  let contentTypes;
  if (hasPosts) {
    const byT = {};
    detail.forEach(d => { const k=d.contentType||"Autre"; byT[k]=byT[k]||{type:k,count:0,rows:[],likes:0,plats:new Set()};
      byT[k].count++; byT[k].rows.push(d); byT[k].likes += d.likes; byT[k].plats.add(PLAT_NICE[d.platform]||d.platform); });
    // reach par créateur unique au sein de chaque type
    contentTypes = Object.values(byT).sort((a,b)=>b.count-a.count).map(t=>({type:t.type,count:t.count,reach:aggReach(t.rows),likes:t.likes,platform:[...t.plats].join(" · ")}));
  } else contentTypes = sd.contentTypes || [];

  const inf = { reach: hasPosts?totReach:(sd.reach||0), imp: hasPosts?totVues:(sd.imp||0),
    posts:nbPosts, likes:sum(detail,"likes"), comments:sum(detail,"comments"), shares:sum(detail,"shares"),
    breakdown, contentTypes };
  const platChips = (breakdown||[]).map(b=>b.platform).filter(Boolean);

  // ── CHROME commun ──────────────────────────────────────────────────────────────
  const crosshairs = `<span class="cross tl"></span><span class="cross tr"></span><span class="cross bl"></span><span class="cross br"></span>`;
  const side = `<div class="side">SMRTVZN · CAMPAIGN TRACKING SYSTEM</div>`;
  const footer = `<div class="foot"><div class="lo"><img class="emblem-img" src="__LOGO_BLUE_URI__" alt="">SMRTVZN</div><div><a href="mailto:contact@smrtvzn.com">contact@smrtvzn.com</a></div><div class="pnum">REPORT / ${esc(artiste.toUpperCase())}, ${esc(titre.toUpperCase())}</div></div>`;
  const detHead = `<thead><tr><th class="l">#</th><th class="l">CRÉATEUR</th><th>FOLLOWERS</th><th>VUES</th><th>LIKES</th><th>COMM.</th><th>PARTAGES</th><th>ENG.</th></tr></thead>`;

  const sheets = []; // {kind, html(without footer/sheetno/chrome wrapper)} -> we wrap later

  // SHEET 1 — SYNTHÈSE
  {
    const chips = platChips.length ? `<div class="chips">${platChips.map(p=>`<span class="chip">${esc(p)}</span>`).join("")}</div>` : "";
    const kpis = `<div class="kpis4">
      <div class="kpi"><span class="kx">[ 01 ]</span><div class="kv">${fmtK(inf.reach)}</div><div class="kl">REACH</div></div>
      <div class="kpi fill"><span class="kx">[ 02 ]</span><div class="kv">${fmtK(inf.imp)}</div><div class="kl">VUES</div></div>
      <div class="kpi"><span class="kx">[ 03 ]</span><div class="kv">${fr(nbPosts)}</div><div class="kl">POSTS TRACÉS</div></div>
      <div class="kpi"><span class="kx">[ 04 ]</span><div class="kv">${engMoy.toFixed(2)}<small>%</small></div><div class="kl">ENG. MOYEN</div></div>
    </div>`;
    const brkRows = (inf.breakdown||[]).map(b => {
      const be = b.imp>0 ? ((b.likes||0)+(b.shares||0))/b.imp*100 : 0;
      return `<tr><td class="c-cre">${esc(b.platform)}</td><td class="num">${fr(b.posts)}</td><td class="num">${fr(b.reach)}</td><td class="num">${fr(b.imp)}</td><td class="num dim">${fr(b.likes)}</td><td class="num dim">${fr(b.shares)}</td><td class="num eng">${be.toFixed(1)}%</td></tr>`;
    }).join("");
    const brk = brkRows ? `<div class="tblhead"><span class="fig">FIG.01</span><h2>RÉPARTITION PAR PLATEFORME</h2><span class="rule"></span><span class="cnt">${(inf.breakdown||[]).length} CANAUX</span></div>
      <table class="brk"><thead><tr><th class="l">PLATEFORME</th><th>POSTS</th><th>REACH</th><th>VUES</th><th>LIKES</th><th>PARTAGES</th><th>ENG.</th></tr></thead><tbody>${brkRows}</tbody></table>` : "";
    const objHTML = objectives.length ? `<div class="objbar">${objectives.map(o=>`<span><b>OBJECTIF.</b> ${esc(o.label)}${o.target?` · cible ${fr(o.target)}`:""}</span>`).join("")}</div>` : "";
    const metaR = [];
    metaR.push(`<div class="meta"><span>ARTISTE</span><b>${esc(artiste)}</b></div>`);
    metaR.push(`<div class="meta"><span>TITRE</span><b>${esc(titre)}</b></div>`);
    if (periode) metaR.push(`<div class="meta"><span>PÉRIODE</span><b>${esc(periode)}</b></div>`);
    if (pkg) metaR.push(`<div class="meta"><span>FORMULE</span><b>${esc(pkg)}</b></div>`);
    metaR.push(`<div class="meta"><span>ÉDITÉ LE</span><b>${dateEd}</b></div>`);
    sheets.push({ kind:"SYNTHÈSE", body: `
      <div class="band"><div class="band-l"><img class="emblem-lg-img" src="__LOGO_DATA_URI__" alt="SMRTVZN"><div><div class="brand">SMRTVZN</div><div class="big"><b>CAMPAIGN</b> / REPORT</div></div></div>
        <div class="band-r">${metaR.join("")}</div></div>
      <div class="conf">CONFIDENTIEL · 001</div>
      <div class="subbar"><span>◆ RAPPORT DE CAMPAGNE&nbsp;&nbsp;&nbsp;SYNTHÈSE GLOBALE</span><span class="sheetno"></span></div>
      ${chips}
      <div class="notebar"><span><b>SYNTHÈSE.</b> ${esc(artiste)} — ${esc(titre)} · ${fr(nbPosts)} contenus tracés sur ${(inf.breakdown||[]).length} plateforme(s), ${fmtK(inf.reach)} de reach cumulé.</span></div>
      ${kpis}
      ${brk}
      ${objHTML}
    `});
  }

  // SHEET 2 — ANALYSE (types de contenu + clip farming)
  if ((inf.contentTypes||[]).length || clip) {
    const ctRows = (inf.contentTypes||[]).slice().sort((a,b)=>b.count-a.count).map(ct =>
      `<tr><td class="c-cre">${esc(ct.type)}</td><td class="num">${fr(ct.count)}</td><td class="num">${fr(ct.reach)}</td><td class="num dim">${fr(ct.likes)}</td><td class="c-plat">${esc(ct.platform||"")}</td></tr>`).join("");
    const ct = ctRows ? `<div class="tblhead"><span class="fig">FIG.02</span><h2>TYPES DE CONTENU / UGC</h2><span class="rule"></span><span class="cnt">${(inf.contentTypes||[]).length} FORMATS</span></div>
      <table class="brk"><thead><tr><th class="l">FORMAT</th><th>VOLUME</th><th>REACH</th><th>LIKES</th><th class="l">PLATEFORME</th></tr></thead><tbody>${ctRows}</tbody></table>` : "";
    const clipBlock = clip ? `<div class="tblhead"><span class="fig">FIG.03</span><h2>CLIP FARMING</h2><span class="rule"></span><span class="cnt">VOLUME</span></div>
      <div class="kpis4 clip">
        <div class="kpi fill"><span class="kx">[ A ]</span><div class="kv">${fmtK(clip.vues)}</div><div class="kl">VUES CUMULÉES</div></div>
        <div class="kpi"><span class="kx">[ B ]</span><div class="kv">${fr(clip.clips)}</div><div class="kl">CLIPS</div></div>
        <div class="kpi"><span class="kx">[ C ]</span><div class="kv">${esc(clip.clippers||clip.clippersNum||"—")}</div><div class="kl">CLIPPERS</div></div>
        <div class="kpi"><span class="kx">[ D ]</span><div class="kv">${fmtK(clip.moyJour)}</div><div class="kl">MOY. / JOUR</div></div>
      </div>` : "";
    sheets.push({ kind:"ANALYSE", body: `
      <div class="band suite"><div class="band-l"><img class="emblem-lg-img" src="__LOGO_DATA_URI__" alt="SMRTVZN"><div><div class="brand dim">REPORT · ${esc(artiste.toUpperCase())}, ${esc(titre.toUpperCase())}</div><div class="big"><b>ANALYSE</b> / CONTENU</div></div></div>
        <div class="band-r"><div class="meta"><span>SHEET</span><b class="sheetno"></b></div><div class="meta"><span>SECTION</span><b>02</b></div></div></div>
      ${ct}
      ${clipBlock}
    `});
  }

  // SHEETS DÉTAIL — par plateforme, paginé
  {
    const items = [];
    groups.forEach(g => { items.push({ t:"head", label:g.label, count:g.rows.length }); g.rows.forEach((r,i)=>items.push({ t:"row", r, rank:i+1 })); });
    const PER = 30; const chunks = []; let cur = [], used = 0;
    for (const it of items) { const cost = it.t==="head"?3:1; if (used+cost>PER && cur.length){ chunks.push(cur); cur=[]; used=0; } cur.push(it); used+=cost; }
    if (cur.length) chunks.push(cur);

    const rowHTML = (r, rank) => { const hot=r.vues>=40000; const eng=r.vues>0?r.eng.toFixed(1)+"%":"—";
      return `<tr><td class="c-rank">${pad(rank)}</td><td class="c-cre"><a class="lnk" href="${esc(r.url)}">${esc(r.account)} ↗</a></td><td class="num">${fr(r.followers)}</td><td class="num${hot?" hot":""}">${fr(r.vues)}</td><td class="num dim">${fr(r.likes)}</td><td class="num dim">${fr(r.comments)}</td><td class="num dim">${fr(r.shares)}</td><td class="num eng">${eng}</td></tr>`; };
    const subHead = (label,count) => `<tr class="grp"><td colspan="8">▸ ${esc(label)} <span>· ${count} créateur(s)</span></td></tr>`;

    chunks.forEach((chunk, idx) => {
      const isFirst = idx===0, isLast = idx===chunks.length-1;
      const body = chunk.map(it => it.t==="head" ? subHead(it.label,it.count) : rowHTML(it.r,it.rank)).join("");
      const legend = isLast ? `<div class="legend"><span><i class="lg-hot"></i>POST À FORTE TRACTION (≥40K VUES)</span><span>ENG. = (LIKES+COMM.+PARTAGES) / VUES</span><span>↗ LIEN CLIQUABLE VERS LE POST</span></div>` : "";
      const title = isFirst ? "DÉTAIL PAR CRÉATEUR" : "DÉTAIL PAR CRÉATEUR · SUITE";
      sheets.push({ kind:"DÉTAIL", body: `
        <div class="band suite"><div class="band-l"><img class="emblem-lg-img" src="__LOGO_DATA_URI__" alt="SMRTVZN"><div><div class="brand dim">REPORT · ${esc(artiste.toUpperCase())}, ${esc(titre.toUpperCase())}</div><div class="big"><b>DÉTAIL</b> / ${isFirst?"CONTENU":"SUITE"}</div></div></div>
          <div class="band-r"><div class="meta"><span>SHEET</span><b class="sheetno"></b></div><div class="meta"><span>CONTENUS</span><b>${detail.length}</b></div></div></div>
        <div class="tblhead"><span class="fig">FIG.04</span><h2>${title}</h2><span class="rule"></span><span class="cnt">${isFirst?`N=${detail.length}`:"CONT."}</span></div>
        <table>${detHead}<tbody>${body}</tbody></table>
        ${legend}
      `});
    });
  }

  // SHEETS PLANNING (optionnel)
  if (planning.length) {
    const pr = planning.slice().sort((a,b)=>String(a.date).localeCompare(String(b.date)));
    const PER = 26; const chunks = [];
    for (let i=0;i<pr.length;i+=PER) chunks.push(pr.slice(i,i+PER));
    chunks.forEach((chunk, idx) => {
      const isFirst = idx===0;
      const rows = chunk.map(e => `<tr><td class="c-cre">${esc(e.date_fr||e.date||"")}</td><td class="num dim" style="text-align:left">${esc(e.heure||"")}</td><td class="c-cre">${esc(e.action||"")}</td><td style="text-align:left">${esc(e.objet||"")}</td><td class="c-plat">${esc(e.nature||"")}${e.priority?' <b style="color:'+IKB+'">●</b>':''}</td></tr>`).join("");
      sheets.push({ kind:"PLANNING", body: `
        <div class="band suite"><div class="band-l"><img class="emblem-lg-img" src="__LOGO_DATA_URI__" alt="SMRTVZN"><div><div class="brand dim">REPORT · ${esc(artiste.toUpperCase())}, ${esc(titre.toUpperCase())}</div><div class="big"><b>PLANNING</b> / ${isFirst?"ÉDITORIAL":"SUITE"}</div></div></div>
          <div class="band-r"><div class="meta"><span>SHEET</span><b class="sheetno"></b></div><div class="meta"><span>ACTIONS</span><b>${planning.length}</b></div></div></div>
        <div class="tblhead"><span class="fig">FIG.05</span><h2>PLANNING ${isFirst?"":"· SUITE"}</h2><span class="rule"></span><span class="cnt">${isFirst?`N=${planning.length}`:"CONT."}</span></div>
        <table class="brk"><thead><tr><th class="l">DATE</th><th class="l">HEURE</th><th class="l">ACTION</th><th class="l">OBJET</th><th class="l">NATURE</th></tr></thead><tbody>${rows}</tbody></table>
      `});
    });
  }

  // SHEET DE CLÔTURE — bandeau d'outro (sa propre page, pas de chevauchement)
  sheets.push({ kind:"OUTRO", body: `
    <div class="band suite"><div class="band-l"><img class="emblem-lg-img" src="__LOGO_DATA_URI__" alt="SMRTVZN"><div><div class="brand dim">REPORT · ${esc(artiste.toUpperCase())}, ${esc(titre.toUpperCase())}</div><div class="big"><b>CLÔTURE</b> / RAPPORT</div></div></div>
      <div class="band-r"><div class="meta"><span>SHEET</span><b class="sheetno"></b></div><div class="meta"><span>FIN</span><b>EOF</b></div></div></div>
    <div class="closing">
      <img class="emblem-xl-img" src="__LOGO_BLUE_URI__" alt="SMRTVZN">
      <div class="ct">FIN DU RAPPORT</div>
      <div class="cs">${esc(artiste)} — ${esc(titre)}</div>
      <div class="crecap">
        <span><b>${(inf.breakdown||[]).length}</b> PLATEFORME(S)</span>
        <span><b>${fr(nbPosts)}</b> CONTENUS TRACÉS</span>
        <span><b>${fmtK(inf.reach)}</b> REACH</span>
        <span><b>${fmtK(inf.imp)}</b> IMPRESSIONS</span>
        <span><b>${engMoy.toFixed(2)}%</b> ENG. MOYEN</span>
      </div>
      <div class="cnote">Rapport généré automatiquement depuis le dashboard SMRTVZN · dashboard.smrtvzn.com<br>SMRTVZN · 66 Avenue des Champs-Élysées, 75008 Paris · contact@smrtvzn.com</div>
    </div>
  `});

  // ── WRAP : pagination SHEET nn/NN ──────────────────────────────────────────────
  const NN = sheets.length;
  const sheetsHTML = sheets.map((s, i) => {
    const no = `${pad(i+1)} / ${pad(NN)}`;
    let b = s.body.replace('<span class="sheetno"></span>', `<span>SHEET ${no}</span>`).replace('<b class="sheetno"></b>', `<b>${no}</b>`);
    const last = i===NN-1;
    return `<section class="sheet${last?" last":""}">${crosshairs}${side}${b}${footer}</section>`;
  }).join("");

  const css = `
    *{box-sizing:border-box;margin:0;padding:0}
    @page{size:A4;margin:0}
    body{background:#fff;color:#0a0a14;font-family:'Inter','Helvetica Neue',Arial,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
    .sheet{position:relative;width:210mm;min-height:297mm;padding:14mm 13mm 16mm;page-break-after:always;background-image:linear-gradient(${IKB}0e 1px,transparent 1px),linear-gradient(90deg,${IKB}0e 1px,transparent 1px);background-size:7mm 7mm}
    .sheet.last{page-break-after:auto}
    .cross{position:absolute;width:10px;height:10px}.cross::before,.cross::after{content:"";position:absolute;background:${IKB}}
    .cross::before{width:10px;height:1px;top:4px}.cross::after{height:10px;width:1px;left:4px}
    .cross.tl{top:6mm;left:6mm}.cross.tr{top:6mm;right:6mm}.cross.bl{bottom:6mm;left:6mm}.cross.br{bottom:6mm;right:6mm}
    .side{position:absolute;right:4mm;top:50%;transform:translateY(-50%) rotate(180deg);writing-mode:vertical-rl;font-family:'SF Mono',monospace;font-size:6px;letter-spacing:3px;color:${IKB}55}
    .band{background:${IKB};color:#fff;display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-radius:2px}
    .band.suite{padding:12px 20px}
    .band-l{display:flex;align-items:center;gap:16px}
    .emblem-lg-img{height:34px;width:auto;display:block}
    .emblem-img{height:12px;width:auto;margin-right:5px;vertical-align:middle}
    .brand{font-family:'SF Mono',monospace;font-size:10px;letter-spacing:4px;opacity:.85}.brand.dim{font-size:8px;letter-spacing:3px;opacity:.7}
    .big{font-size:25px;font-weight:300;letter-spacing:1px;margin-top:2px}.big b{font-weight:800}.band.suite .big{font-size:21px}
    .band-r{display:flex;flex-direction:column;gap:6px;min-width:160px}
    .meta{font-family:'SF Mono',monospace}.meta span{display:block;font-size:7px;letter-spacing:2px;opacity:.6}.meta b{font-size:12px;font-weight:700}
    .conf{position:absolute;top:6mm;right:14mm;font-family:'SF Mono',monospace;font-size:7px;letter-spacing:3px;color:${IKB}}
    .subbar{display:flex;justify-content:space-between;margin-top:13px;font-family:'SF Mono',monospace;font-size:8px;letter-spacing:2px;color:${IKB}}
    .chips{display:flex;gap:6px;margin-top:10px;flex-wrap:wrap}
    .chip{font-family:'SF Mono',monospace;font-size:8px;letter-spacing:1px;color:${IKB};border:1px solid ${IKB}40;padding:3px 9px;border-radius:2px}
    .notebar{margin-top:11px;padding:8px 0;border-top:1px solid ${IKB}22;border-bottom:1px solid ${IKB}22;font-size:9px;color:#3a3a52}.notebar b{color:${IKB}}
    .objbar{margin-top:10px;display:flex;flex-direction:column;gap:4px;font-size:8.5px;color:#5a5a70}.objbar b{color:${IKB}}
    .kpis4{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-top:13px}.kpis4.clip{margin-top:6px}
    .kpi{position:relative;border:1px solid ${IKB}33;padding:14px 14px}
    .kpi::before,.kpi::after{content:"";position:absolute;width:8px;height:8px;border:1.5px solid ${IKB}}
    .kpi::before{top:-1px;left:-1px;border-right:none;border-bottom:none}.kpi::after{bottom:-1px;right:-1px;border-left:none;border-top:none}
    .kpi.fill{background:${IKB}}.kpi.fill .kv,.kpi.fill .kl,.kpi.fill .kx{color:#fff}.kpi.fill::before,.kpi.fill::after{border-color:#fff}
    .kx{font-family:'SF Mono',monospace;font-size:7px;letter-spacing:2px;color:${IKB}99}
    .kv{font-family:'SF Mono',monospace;font-size:27px;font-weight:800;color:${IKB};line-height:1.1;margin-top:5px}.kv small{font-size:14px}
    .kl{font-family:'SF Mono',monospace;font-size:7.5px;letter-spacing:1.5px;color:${IKB};margin-top:3px}
    .tblhead{display:flex;align-items:center;gap:12px;margin-top:15px;margin-bottom:6px}
    .fig{background:${IKB};color:#fff;font-family:'SF Mono',monospace;font-size:8px;letter-spacing:1px;padding:3px 7px}
    .tblhead h2{font-family:'SF Mono',monospace;font-size:11px;letter-spacing:2px;color:${IKB};font-weight:700}
    .tblhead .rule{flex:1;height:1px;background:${IKB}33}.tblhead .cnt{font-family:'SF Mono',monospace;font-size:8px;color:${IKB}99}
    table{width:100%;border-collapse:collapse;font-family:'SF Mono',monospace}
    thead tr{background:${IKB}}th{color:#fff;font-size:8px;letter-spacing:1px;font-weight:600;padding:6px 8px;text-align:right}th.l{text-align:left}
    tbody tr{border-bottom:1px solid ${IKB}14}tbody tr:nth-child(even){background:${IKB}06}
    td{font-size:9px;padding:5px 8px;text-align:right;color:#1a1a2e}
    td.c-rank{color:${IKB};font-weight:700;text-align:left}td.c-cre{text-align:left;font-weight:700;color:#0a0a14}
    td.c-plat{text-align:left;color:#7a7a92;font-size:8px}
    td.num.dim{color:#7a7a92}td.num.hot{color:${IKB};font-weight:700;background:${IKB}12}td.num.eng{color:${IKB};font-weight:700}
    tr.grp td{background:${IKB}10;color:${IKB};font-weight:700;text-align:left;font-size:8.5px;letter-spacing:1px;padding:5px 8px}tr.grp span{color:${IKB}88;font-weight:400}
    a.lnk{color:#0a0a14;text-decoration:none}a.lnk:hover{color:${IKB}}
    .legend{display:flex;gap:22px;margin-top:11px;font-family:'SF Mono',monospace;font-size:7px;letter-spacing:1px;color:#7a7a92;align-items:center;flex-wrap:wrap}
    .legend i{display:inline-block;width:9px;height:9px;margin-right:5px;vertical-align:middle}.legend .lg-hot{background:${IKB}30;border:1px solid ${IKB}}
    .closing{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;margin-top:60mm}
    .emblem-xl-img{height:64px;width:auto;display:block}
    .ct{font-family:'SF Mono',monospace;font-size:22px;font-weight:800;letter-spacing:4px;color:${IKB};margin-top:18px}
    .cs{font-family:'SF Mono',monospace;font-size:11px;letter-spacing:2px;color:#5a5a70;margin-top:6px}
    .crecap{display:flex;gap:0;margin-top:26px;border:1px solid ${IKB}33}
    .crecap span{font-family:'SF Mono',monospace;font-size:8px;letter-spacing:1px;color:#5a5a70;padding:10px 16px;border-right:1px solid ${IKB}22}
    .crecap span:last-child{border-right:none}.crecap b{display:block;font-size:16px;color:${IKB};margin-bottom:3px}
    .cnote{font-family:'SF Mono',monospace;font-size:7px;letter-spacing:1px;color:#9a9ab0;margin-top:26px;line-height:1.7}
    .foot{position:absolute;bottom:8mm;left:13mm;right:13mm;display:flex;justify-content:space-between;align-items:center;border-top:1px solid ${IKB}22;padding-top:8px;font-family:'SF Mono',monospace;font-size:7px;letter-spacing:1px;color:#9a9ab0}
    .foot .lo{display:flex;align-items:center;font-weight:700;color:${IKB};letter-spacing:2px}.foot a{color:#9a9ab0;text-decoration:none}.foot .pnum{letter-spacing:2px}
  `;
  let html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>SMRTVZN_Report_${esc(artiste)}_${esc(titre)}</title><style>${css}</style></head><body>${sheetsHTML}</body></html>`;

  // Génère un vrai fichier .pdf et le télécharge directement (comme l'Excel).
  const fileName = `SMRTVZN_Rapport_${artiste}_${titre}`.replace(/[^\w\-]+/g, "_") + ".pdf";
  const loadScript = (src, ready) => new Promise((res, rej) => {
    if (ready()) return res();
    const s = document.createElement("script"); s.src = src;
    s.onload = () => res(); s.onerror = () => rej(new Error("Chargement " + src));
    document.head.appendChild(s);
  });
  const printFallback = () => {
    const w = window.open("", "_blank");
    if (w && w.document) { w.document.open(); w.document.write(html.replace("</body>", '<scr'+'ipt>onload=function(){setTimeout(function(){try{print()}catch(e){}},400)}<\/scr'+'ipt></body>')); w.document.close(); }
    else alert("Autorise les téléchargements / pop-up pour ce site, puis réessaie.");
  };
  // Convertit l'asset bundlé en data-URI base64 (inline → garantit le rendu html2canvas)
  const urlToDataURI = async (url) => {
    const resp = await fetch(url);
    const blob = await resp.blob();
    return await new Promise((res, rej) => {
      const fr = new FileReader();
      fr.onload = () => res(fr.result);
      fr.onerror = rej;
      fr.readAsDataURL(blob);
    });
  };
  (async () => {
    // Injecter les logos : base64 inline si possible, sinon repli sur l'URL webpack.
    let logoSrc = logoWhite;
    try { const d = await urlToDataURI(logoWhite); if (d) logoSrc = d; } catch {}
    let logoBlueSrc = logoBlue;
    try { const d = await urlToDataURI(logoBlue); if (d) logoBlueSrc = d; } catch {}
    html = html
      .replace(/__LOGO_DATA_URI__/g, () => logoSrc)
      .replace(/__LOGO_BLUE_URI__/g, () => logoBlueSrc);
    try {
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js", () => window.html2canvas);
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", () => window.jspdf && window.jspdf.jsPDF);
    } catch (e) { printFallback(); return; }
    const iframe = document.createElement("iframe");
    Object.assign(iframe.style, { position: "fixed", left: "-10000px", top: "0", width: "794px", height: "1200px", border: "0", opacity: "0" });
    document.body.appendChild(iframe);
    await new Promise(r => { iframe.onload = r; iframe.srcdoc = html; setTimeout(r, 1800); });
    await new Promise(r => setTimeout(r, 450));
    try {
      const idoc = iframe.contentDocument;
      iframe.style.height = (idoc.documentElement.scrollHeight || 1200) + "px";
      await new Promise(r => setTimeout(r, 150));
      const sheets = Array.from(idoc.querySelectorAll(".sheet"));
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
      for (let i = 0; i < sheets.length; i++) {
        const canvas = await window.html2canvas(sheets[i], { scale: 2, backgroundColor: "#ffffff", useCORS: true, windowWidth: 794, width: 794, logging: false });
        const img = canvas.toDataURL("image/jpeg", 0.92);
        if (i > 0) pdf.addPage();
        pdf.addImage(img, "JPEG", 0, 0, 210, 297, undefined, "FAST");

        // html2canvas aplatit la page en image → les <a> perdent leur lien.
        // On recolle des annotations cliquables jsPDF par-dessus, pointant vers l'URL exacte.
        const sheetRect = sheets[i].getBoundingClientRect();
        const kx = 210 / sheetRect.width;   // px → mm horizontal
        const ky = 297 / sheetRect.height;  // px → mm vertical
        sheets[i].querySelectorAll("a[href]").forEach(a => {
          const href = a.getAttribute("href");
          if (!href || !/^(https?:|mailto:)/i.test(href)) return;
          const r = a.getBoundingClientRect();
          pdf.link((r.left - sheetRect.left) * kx, (r.top - sheetRect.top) * ky,
                   r.width * kx, r.height * ky, { url: href });
        });
      }
      pdf.save(fileName);
    } catch (e) { printFallback(); }
    finally { try { document.body.removeChild(iframe); } catch (_) {} }
  })();
  return html;
}

// ── EXPORT EXCEL — données + liens cliquables (SheetJS via cdnjs, 0 install) ────
export async function exportCampaignXLSX(client, posts, influenceData) {
  if (typeof window === "undefined") return;
  if (!window.XLSX) {
    await new Promise((res, rej) => {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      s.onload = res; s.onerror = () => rej(new Error("Chargement SheetJS impossible"));
      document.head.appendChild(s);
    });
  }
  const XLSX = window.XLSX;
  const artiste = client.label || client.name || "Campagne";
  const titre = client.project || "";
  const ORDER = { TikTok: 0, Twitter: 1, Instagram: 2 };
  const fmtPlat = p => p === "TikTok" ? "TikTok" : p === "Twitter" ? "Twitter / X" : p;
  const rows = (posts || [])
    // On garde les liens courts vm.tiktok.com / vt.tiktok.com (vrais posts) ;
    // seules les pages "son" TikTok sont exclues. @handle/plateforme déduits de l'URL.
    .filter(p => p.url && !p.url.includes("tiktok.com/music"))
    .map(p => { const vues = p.views || p.impressions || p.imp || 0;
      const platform = p.platform || _platFromUrl(p.url);
      const account = p.account || _acctFromUrl(p.url, platform) || "";
      return { platform, account, type:p.contentType||p.type||"", url:p.url,
        followers:p.followers||0, vues, likes:p.likes||0,
        comments:(p.comments!=null?p.comments:p.replies)||0, shares:(p.shares!=null?p.shares:p.reposts)||0, saves:p.saves||0 }; })
    .sort((a, b) => ((ORDER[a.platform] ?? 9) - (ORDER[b.platform] ?? 9)) || ((b.followers || 0) - (a.followers || 0)));
  if (!rows.length) { alert("Aucun lien à exporter pour cette campagne."); return; }

  const now = new Date(); const pad = x => String(x).padStart(2, "0");
  const header = ["#", "Plateforme", "Créateur", "Type", "Lien", "Followers", "Vues", "Likes", "Commentaires", "Partages", "Enregistrements", "Engagement %"];
  const aoa = [
    ["SMRTVZN — Données campagne"],
    [artiste + (titre ? " · " + titre : "")],
    ["Édité le " + pad(now.getDate()) + "/" + pad(now.getMonth() + 1) + "/" + now.getFullYear() + " · " + rows.length + " liens"],
    [],
    header,
  ];
  const firstDataRow = aoa.length;
  rows.forEach((p, i) => {
    const eng = p.vues > 0 ? (p.likes + p.comments + p.shares) / p.vues * 100 : 0;
    aoa.push([i + 1, fmtPlat(p.platform), p.account, p.type, p.url, p.followers, p.vues, p.likes, p.comments, p.shares, p.saves, +eng.toFixed(2)]);
  });
  const sum = k => rows.reduce((s, p) => s + (p[k] || 0), 0);
  aoa.push([]);
  aoa.push(["", "TOTAL", rows.length + " liens", "", "", "", sum("vues"), sum("likes"), sum("comments"), sum("shares"), sum("saves"), ""]);

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  rows.forEach((p, i) => {
    const cell = XLSX.utils.encode_cell({ r: firstDataRow + i, c: 4 });
    if (ws[cell]) ws[cell].l = { Target: p.url, Tooltip: "Ouvrir le post" };
  });
  ws["!cols"] = [{ wch: 4 }, { wch: 13 }, { wch: 22 }, { wch: 18 }, { wch: 58 }, { wch: 11 }, { wch: 11 }, { wch: 10 }, { wch: 13 }, { wch: 10 }, { wch: 15 }, { wch: 13 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Liens & Données");

  if (influenceData && influenceData.breakdown && influenceData.breakdown.length) {
    const s2 = [["Synthèse — " + artiste + (titre ? " · " + titre : "")], [], ["Plateforme", "Posts", "Reach", "Impressions", "Likes", "Partages"]];
    influenceData.breakdown.forEach(b => s2.push([b.platform, b.posts || 0, b.reach || 0, b.imp || 0, b.likes || 0, b.shares || 0]));
    s2.push([]);
    s2.push(["TOTAL", influenceData.posts || rows.length, influenceData.reach || 0, influenceData.imp || 0, influenceData.likes || 0, influenceData.shares || 0]);
    const ws2 = XLSX.utils.aoa_to_sheet(s2);
    ws2["!cols"] = [{ wch: 16 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 12 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, ws2, "Synthèse");
  }
  const safe = s => String(s).replace(/[^\w\-]+/g, "_");
  XLSX.writeFile(wb, `SMRTVZN_Donnees_${safe(artiste)}_${safe(titre)}.xlsx`);
}
